export const unityFilePathRoot = 'https://game.local/main';
